/**
 * What the free tier gives, and what it withholds (epic #121, ADR-014).
 *
 * These numbers MIRROR THE SERVER and do not decide anything. The device cap is enforced by
 * RegisterAgentDeviceHandler, retention by AgentEventsPartitionMaintainer, and configuration access by
 * PersonalOrgConfigurationFilter. What is here exists only so the interface can explain the limit
 * before the user hits it, which is the difference between a boundary and an error.
 */
export const FREE_TIER = {
  /** RegisterAgentDeviceHandler.PersonalDeviceLimit. */
  deviceLimit: 2,
  /** AgentEventsPartitionMaintainer.FreeTierRetention, in days. */
  retentionDays: 7,
} as const;

/**
 * Where an upsell was shown. Must match UpsellSurfaces on the server, which refuses anything else -
 * a deliberately closed vocabulary, so that the funnel store can never become a channel for free-form
 * text (story #137).
 */
export type UpsellSurface =
  | 'device_limit'
  | 'retention_boundary'
  | 'invite_team'
  | 'locked_feature'
  | 'plan_settings';

/** The routes a personal organization has no access to, so the nav and the router agree on one list. */
export const TEAM_ONLY_PATHS = ['/policies', '/ai-services', '/package-security'] as const;

export function isTeamOnlyPath(path: string): boolean {
  return TEAM_ONLY_PATHS.some((p) => path === p || path.startsWith(`${p}/`));
}
